module.exports = __webpack_public_path__ + "img/cans.0943b5a.png";